/**
 * Archive Product - Courses JS
 */

// CSS
import styles from '../scss/archive-product-with-filters.scss';

const $ = window.jQuery;

// Components
import './components/vendor-facetwp';
import './components/filters';

// Products view switcher
$('html').on('click', '[data-products-view-switch]', (event) => {
  if (typeof event !== 'undefined') {
    event.preventDefault();
  }
  const self = $(event.currentTarget);
  const view = $(event.currentTarget).data('products-view-switch');
  self
    .addClass('is-active')
    .siblings('[data-products-view-switch]')
    .removeClass('is-active');
  $('[data-products-view]').attr('data-products-view', view);
});
